module.exports = __webpack_public_path__ + "static/app_bar_2-d3781c6ab114b4790354be0cb2d35203.png";